export enum ManualDeliveryProperties {
  deleteDialogWidth = '650px',
  previewDialogWidth = '650px',
  registerDialogWidth = '650px'
}
